export const subDataBorColor = [
    'rgba(34,211,238,1)',
                'rgba(239,68,68,1)',
                'rgba(74,222,128,1)',
                'rgba(94,234,212,1)',
                'rgba(249,115,22,1)',
                'rgba(251,191,36,1)',
                'rgba(34,211,238,1)',
                'rgba(163,230,53,1)',
                'rgba(124,58,237,1)',
                'rgba(217,70,239,1)',
                'rgba(236,72,153,1)',
                'rgba(244,63,94,1)'
]